let nextPageID;
let currentPageID;
let pastPageID;
let pastPastPageID;
let menuActiveID;
let menuPasstID = 0;
let load = true;
let subMenuCategoryID = 0;
let carousel = [];
let scrool = 0;
let userHasScrolled = false;
let i = 0;
let disableChangePage = 2000;
let tmpScrool;
let scroolHash = false;

(() => {
  const hamburger = document.querySelector('.hamburger');
  const hamburgerTimeline = document.querySelector('.timeline__hamburger');
  const timeline = document.querySelector('.timeline');
  const navPrimary = document.querySelector('.nav__primary');
  const logo = document.querySelector('.logo');
  const header = document.querySelector('header');
  const timelineItems = document.querySelectorAll('.timeline .point');
  const timelineInfo = document.querySelector('.timeline__info');
  const timelineInfoExit = document.querySelector('.timeline__info__exit');

  if (timelineInfoExit) {
    timelineInfoExit.addEventListener('click', closeTimeLineContent);
  }
  setTimeout(() => {
    const lightboxItem = document.querySelectorAll('.lightbox');
    if (lightboxItem.length !== 0) {
      initLightbox();
    }
  }, 600);
  timelineItems.forEach(item => {
    item.addEventListener('click', function() {
      const conteinerWidth = $(this).data('width');
      document.querySelector('body').classList.add('showedDataTimeline');
      if (conteinerWidth == 100) {
        document
          .querySelector('body')
          .classList.add('showedDataTimelineSpecial');
        timelineInfo.style.width = '100%';
        timelineInfo.style.maxWidth = '100%';
        document
          .querySelector('.timeline__info__body')
          .classList.add('timeline__special');
      } else {
        timelineInfo.style.width = '';
        timelineInfo.style.maxWidth = '';
        document
          .querySelector('.timeline__info__body')
          .classList.remove('timeline__special');
      }
      timelineInfo.classList.add('active');
    });
    item.addEventListener('click', timelineDataLoad);
  });

  hamburger.addEventListener('click', function() {
    logo.classList.toggle('menu-acitve');
    header.classList.toggle('menu-acitve');
    this.classList.toggle('active');
    this.classList.toggle('not-active');
    navPrimary.classList.toggle('active');
  });
  hamburgerTimeline.addEventListener('click', function() {
    this.classList.toggle('active');
    timeline.classList.toggle('active');
  });
  if (window.innerWidth > 1170) {
    const body = document.querySelector('body');
    window.addEventListener(
      'wheel',
      function(e) {
        if (!body.classList.contains('showedDataTimeline')) {
          const buttonPast = document.querySelector('.show .page__past span');
          const buttonNext = document.querySelector('.show .page__next span');

          if (e.deltaY < 0) {
            if (buttonPast) {
              buttonPast.click();
              if (load) {
                load = false;
              }
            }
          }
          if (e.deltaY > 0) {
            if (buttonNext) {
              buttonNext.click();
              if (load) {
                load = false;
              }
            }
          }
        }
      },
      { passive: false }
    );
  }
})();

function maxWidthImage() {
  let images = document.querySelectorAll('.container__moved img');
  let timeLinesImages = document.querySelectorAll('.timeline__img img');
  if (timeLinesImages.length !== 0) {
    timeLinesImages.forEach(img => {
      let width = img.clientWidth;
      let parentNode = img.parentNode;
      if (width === 0 || Number.isNaN(width) || width === '') {
      } else {
        parentNode.style.maxWidth = width + 'px';
      }
    });
  }
  //or however you get a handle to the IMG
  images.forEach(img => {
    let width = img.clientWidth;
    let parentNode = img.parentNode;
    if (width === 0 || Number.isNaN(width) || width === '') {
    } else {
      parentNode.style.maxWidth = width + 'px';
    }
  });
}

function initLinkAction() {
  const link = document.querySelectorAll('.container__moved a');
  link.forEach(item => {
    item.addEventListener('click', function(e) {
      const currentUrlHostname = new URL(document.URL).hostname;
      const href = this.href;
      const url = new URL(href);
      const link = url.protocol + '//' + url.host + url.pathname;
      const hostname = url.hostname;
      const pathname = url.pathname;
      const hash = url.hash;
      scroolHash = hash;
      const ajaxurl = my_ajax_object.ajaxurl;
      if (currentUrlHostname === hostname) {
        e.preventDefault();
        if (pathname.includes('timeline')) {
          const timeLineItems = document.querySelectorAll(
            '.timeline__container .point'
          );
          // console.log(href);
          // console.log(item.dataset.url);
          timeLineItems.forEach(item => {
            if (link === item.dataset.url) {
              item.click();
            }
          });
        } else if (pathname.includes('uploads')) {
        } else {
          const data = {
            url: href,
            action: 'ajax_get_id'
          };
          $.ajax({
            url: ajaxurl,
            type: 'post',
            data: data,
            error: function(response) {
              console.log(response);
            },
            success: function(response) {
              nav(e, response, hash);
            }
          });
        }
      }
    });
  });
}

function closeTimeLineContent() {
  const TimelineConten = document.querySelector('.timeline__info ');
  const body = document.querySelector('body ');

  TimelineConten.style.right = '-50%';
  TimelineConten.style.opacity = '0';

  setTimeout(() => {
    body.classList.remove('showedDataTimeline');
    body.classList.remove('showedDataTimelineSpecial');

    TimelineConten.classList.remove('active');
    TimelineConten.style.right = '';
    TimelineConten.style.opacity = '';
  }, 300);
}

function subMenuCategory() {
  const categoryID = document.querySelector('.wrapper.show').dataset.menu;
  const currentItem = document.querySelector('.wrapper.show').dataset
    .categoryline;
  const itemsNumber = document.querySelector('.wrapper.show').dataset
    .categorynumberpage;
  const container = document.querySelector('.category__line');

  if (menuActiveID !== subMenuCategoryID) {
    const itemsElement = container.querySelectorAll('div');
    itemsElement.forEach((element, index) => {
      element.remove();
    });
  }
  if (subMenuCategoryID !== categoryID) {
    subMenuCategoryID = categoryID;
    for (let i = 0; i < itemsNumber; i++) {
      const element = document.createElement('div');
      container.appendChild(element);
    }
  }

  const itemsElement = container.querySelectorAll('div');
  itemsElement.forEach((element, index) => {
    if (index < currentItem) {
      setTimeout(() => {
        element.classList.add('active');
      }, 10);
    } else {
      element.classList.remove('active');
    }
  });
}

function initLightbox(items) {
  const tobi = new Tobi({
    selector: '.lightbox',
    captions: true,
    counter: false,
    keyboard: false,
    zoom: false,
    draggable: false,
    nav: false,
    keyboard: false
  });
}

function destroySlider() {
  const carouselContainer = document.querySelector('.show .seciton__slider');
  if (carouselContainer) {
    carousel.destroy();
  }
}

function initSlider() {
  const carouselContainer = document.querySelector('.show .seciton__slider');

  if (carouselContainer) {
    function showButton(event) {
      var items = event.item.count;
      var item = event.item.index;
      let nextButton = document.querySelector('.show .section__next');
      let prevButton = document.querySelector('.show .section__past');

      if (items == item + 1) {
        nextButton.style.opacity = 0;
      } else {
        nextButton.style.opacity = 1;
      }
      if (0 == item) {
        prevButton.style.opacity = 0;
      } else {
        prevButton.style.opacity = 1;
      }
    }

    const prev = document.querySelector('.show .section__past');
    const next = document.querySelector('.show .section__next');
    let owl = $(carouselContainer);
    owl.owlCarousel({
      items: 1,
      nav: false,
      dots: false
    });

    owl.on('changed.owl.carousel', function(event) {
      showButton(event);
    });
    $(prev).click(function() {
      owl.trigger('prev.owl.carousel');
    });
    $(next).click(function() {
      owl.trigger('next.owl.carousel');
    });
  }
}

function updetaTimeline() {
  const activeLine = document.querySelector('.activeLine');
  const currentPositionTimeLine = document
    .querySelector('.timeline__container')
    .getBoundingClientRect();
  const currentPageYear = document.querySelector('.show.wrapper').dataset.year;
  const currentPageYearTimeline = document
    .querySelector('span[data-timelineyear="' + currentPageYear + '"]')
    .getBoundingClientRect();

  const getFirstYear = document.querySelector(
    '.timeline__container .show:first-child'
  ).dataset.timelineyear;

  document
    .querySelectorAll('.timeline__container span')
    .forEach(ele => ele.classList.remove('active'));

  for (let i = getFirstYear; i <= currentPageYear; i++) {
    const tmp = document.querySelector('span[data-timelineyear="' + i + '"]');
    tmp.classList.add('active');
  }
  activeLine.style.height =
    currentPageYearTimeline.top - currentPositionTimeLine.top + 'px';
}

const firstLoad = (function() {
  let executed = false;

  return function() {
    if (!executed) {
      executed = true;
      const pageID = +$('.page_id').html();
      const ajaxurl = my_ajax_object.ajaxurl;
      const data = {
        pageID,
        action: 'ajax_section_get_page'
      };
      //ajax call
      $.ajax({
        url: ajaxurl,
        type: 'post',
        data: data,
        error: function(response) {
          console.log(response);
        },
        success: function(response) {
          $('.page__load').append(response);
          currentPageID = pageID;
          i = pageID;
          $('.wrapper[data-container=' + currentPageID + ']').addClass('show');
          const logo = document.querySelector('.logo');
          const currentPageYear = document.querySelector('.wrapper.show')
            .dataset.year;
          if (currentPageYear) {
            const timeLineYear = document.querySelector(
              '.timeline__header__year'
            );
            timeLineYear.innerHTML = currentPageYear;
          }
          const currentPageMenuId = document.querySelector('.wrapper.show')
            .dataset.menu;
          menuActiveID = currentPageMenuId;
          subMenuCategory();
          updetaTimeline();
          if (logo) {
            setTimeout(() => {
              logo.classList.add('load');
              $('.nav__left__item').removeClass('nav__left__item--active');
              $('.nav__left__item[data-item=' + currentPageID + ']').addClass(
                'nav__left__item--active'
              );
              const logoColor = document.querySelector('.wrapper.show').dataset
                .logocolor;
              const logoChange = document.querySelectorAll('.logo.load path');
              logoChange.forEach(item => {
                item.style.fill = logoColor;
              });
              // const lightboxItem = document.querySelectorAll('.lightbox');
              // if (lightboxItem.length !== 0) {
              //   initLightbox();
              // }
              nextLoad();
              pastLoad();
              initScrollBarMobile();
              initAudio();
              maxWidthImage();
              initVideo();
              initLinkAction();
              // initParalax();
              initSlider();
            }, 1500);
          }
        }
      });
    }
  };
})();

function pastLoad() {
  pastPageID = $('.show .page__past span').data('past');
  const ajaxurl = my_ajax_object.ajaxurl;
  const data = {
    pageID: pastPageID,
    action: 'ajax_section_get_page'
  };
  const buttonPast = document.querySelector('.show .page__past span');
  if (buttonPast) {
    buttonPast.addEventListener('click', changePagePast);
  }
  const buttonNext = document.querySelector('.show .page__next span');
  if (buttonNext) {
    buttonNext.addEventListener('click', changePageNext);
  }
  if (pastPageID === pastPastPageID) {
    return null;
  }
  if (pastPastPageID === 0) {
    return null;
  }
  //ajax call
  $.ajax({
    url: ajaxurl,
    type: 'post',
    data: data,
    error: function(response) {
      console.log(response);
    },
    success: function(response) {
      //check
      if (response === 'no page') {
      } else {
        // destroySlider();
        $('.page__load').prepend(response);
        let pastPage = $('.wrapper[data-currentpage=' + pastPageID + ']');
        $(pastPage).css('margin-top', '-100vh');
        const buttonPast = document.querySelector('.show .page__past span');
        if (buttonPast) {
          buttonPast.addEventListener('click', changePagePast);
        }
        const buttonNext = document.querySelector('.show .page__next span');
        if (buttonNext) {
          buttonNext.addEventListener('click', changePageNext);
        }
        initParalax();
        initScrollBarMobile();
      }
    }
  });
}

function nextLoad() {
  nextPageID = $('.show .page__next span').data('next');
  const ajaxurl = my_ajax_object.ajaxurl;
  const data = {
    pageID: nextPageID,
    action: 'ajax_section_get_page'
  };
  //ajax call
  $.ajax({
    url: ajaxurl,
    type: 'post',
    data: data,
    error: function(response) {
      console.log(response);
    },
    success: function(response) {
      //check
      if (response === 'no page') {
      } else {
        $('.page__load').append(response);
        const buttonPast = document.querySelector('.show .page__past span');
        if (buttonPast) {
          buttonPast.addEventListener('click', changePagePast);
        }
        const buttonNext = document.querySelector('.show .page__next span');
        if (buttonNext) {
          buttonNext.addEventListener('click', changePageNext);
        }
        initParalax();
        initScrollBarMobile();
      }
    }
  });
}

function formatSecondsAsTime(secs) {
  let hr = Math.floor(secs / 3600);
  let min = Math.floor((secs - hr * 3600) / 60);
  let sec = Math.floor(secs - hr * 3600 - min * 60);

  // if (min < 10) {
  //   min = '0' + min;
  // }
  if (sec < 10) {
    sec = '0' + sec;
  }
  if (Number.isNaN(min)) {
    return '';
  } else {
    return min + ':' + sec;
  }
}

function controlAudio(item) {
  let isPlaying;
  const player = item.querySelector('audio');
  const start = item.querySelector('.conrtols__play');
  const stop = item.querySelector('.conrtols__stop');
  const progressBar = item.querySelector('.audio__progress-bar');
  const progress = item.querySelector('.progress');
  const time = item.querySelector('.conrtols__time');
  const volume = item.querySelector('.conrtols__value');
  const progressBarContainer = item.querySelector(
    '.conrtols__seek-info .progress__container'
  );
  const infoContainer = item.querySelector(
    '.conrtols__seek-info .conrtols__info'
  );

  player.addEventListener(
    'timeupdate',
    function() {
      updateProgressBar(player, progressBar);
      updateAudioTime(player, time, item);
    },
    false
  );

  function updateAudioTime(player, time) {
    const currectTime = Math.floor(player.currentTime).toString();
    time.innerHTML = formatSecondsAsTime(currectTime);
  }

  progressBar.addEventListener('click', function(e) {
    seek(e, player, this);
  });

  function seek(e, player, thisBind) {
    var percent = e.offsetX / thisBind.offsetWidth;
    player.currentTime = percent * player.duration;
    e.target.value = Math.floor(percent / 100);
    e.target.innerHTML = progressBar.value + '% played';
  }

  player.volume = 0.75;

  updateTrackTime();
  start.addEventListener('click', togglePlay);
  stop.addEventListener('click', togglePlay);
  volume.addEventListener('click', toogleVolume);
  player.onended = endPlay;
  player.ontimeupdate = updateTrackTime;

  function toogleVolume() {
    if (player.volume === 0) {
      player.volume = 0.75;
      volume.classList.remove('muted');
    } else {
      player.volume = 0;
      volume.classList.add('muted');
    }
  }

  function endPlay() {
    isPlaying = false;
    updateTrackTime();
    progressBarContainer.classList.toggle('hidde');
    infoContainer.classList.toggle('hidde');
    start.classList.toggle('hidde');
    stop.classList.toggle('hidde');
  }

  function togglePlay() {
    if (player.paused === false) {
      player.pause();
      isPlaying = false;
      progressBarContainer.classList.toggle('hidde');
      infoContainer.classList.toggle('hidde');
      start.classList.toggle('hidde');
      stop.classList.toggle('hidde');
    } else {
      player.play();
      progressBarContainer.classList.toggle('hidde');
      infoContainer.classList.toggle('hidde');
      start.classList.toggle('hidde');
      stop.classList.toggle('hidde');
      isPlaying = true;
    }
  }

  function updateTrackTime() {
    const currectTime = Math.floor(
      player.duration - player.currentTime
    ).toString();
    if (Number.isNaN(currectTime)) {
      time.innerHTML = '';
    } else {
      time.innerHTML = '-' + formatSecondsAsTime(currectTime);
    }
  }

  let timer;
  let percent = 0;
  player.addEventListener('playing', function(_event) {
    const duration = _event.target.duration;
    advance(duration, player);
  });

  player.addEventListener('pause', function(_event) {
    clearTimeout(timer);
  });

  function advance(duration, element) {
    let increment = 10 / duration;
    percent = Math.min(increment * element.currentTime * 10, 100);
    startTimer(duration, element);
  }

  const startTimer = function(duration, element) {
    if (percent < 100) {
      timer = setTimeout(function() {
        advance(duration, element);
      }, 100);
    }
  };
}

function initVideo() {
  const videoPlayerContainer = document.querySelectorAll('.row_video');
  if (videoPlayerContainer.length !== 0) {
    videoPlayerContainer.forEach(item => {
      controlvideo(item);
    });
  }
}
function controlvideo(item) {
  // Get a handle to the player
  let player = item.querySelector('.video__video-element');
  let playerContainer = item.querySelector('.video__video-container');
  let btnPlayPause = item.querySelector('.video__controls__play-stop');
  let progressBar = item.querySelector('.video__progress-bar');
  let volumeBar = item.querySelector('.video__volume-bar');
  let time = item.querySelector('.video__controls__play__time_currect');
  let timeFull = item.querySelector('.video__controls__play__time_end');
  let itemMute = item.querySelector('.video__btnMute img');

  if (Number.isNaN(player.duration)) {
    timeFull.innerHTML = '';
  } else {
    timeFull.innerHTML = formatSecondsAsTime(player.duration);
  }

  itemMute.addEventListener('click', function() {
    muteVolume(player, itemMute);
  });

  player.volume = 0.5;

  btnPlayPause.addEventListener('click', function() {
    playPauseVideo(player, item, playerContainer);
  });

  playerContainer.addEventListener('click', function() {
    playPauseVideo(player, item, playerContainer);
  });
  // item.querySelector('.video__btnFullScreen').disabled = true;
  // Add a listener for the timeupdate event so we can update the progress bar
  player.addEventListener(
    'timeupdate',
    function() {
      updateProgressBar(player, progressBar);
      updateVideoTime(player, time, item);
    },
    false
  );

  // Add a listener for the play and pause events so the buttons state can be updated
  player.addEventListener(
    'play',
    function() {
      // Change the button to be a pause button
      changeButtonType(item, 'pause');
    },
    false
  );

  player.addEventListener(
    'pause',
    function() {
      // Change the button to be a play button
      changeButtonType(item, 'play');
    },
    false
  );

  // player.addEventListener(
  //   'volumechange',
  //   function(e) {
  //     // Update the button to be mute/unmute
  //     if (player.muted) changeButtonTypeVal(btnMute, 'unmute');
  //     else changeButtonTypeVal(btnMute, 'mute');
  //   },
  //   false
  // );

  player.addEventListener(
    'ended',
    function() {
      this.pause();
    },
    false
  );

  progressBar.addEventListener('click', function(e) {
    seek(e, player, this);
  });

  volumeBar.addEventListener('click', function(e) {
    seekVolume(e, player, this);
  });

  function seek(e, player, thisBind) {
    var percent = e.offsetX / thisBind.offsetWidth;
    player.currentTime = percent * player.duration;
    e.target.value = Math.floor(percent / 100);
    e.target.innerHTML = progressBar.value + '% played';
  }

  function seekVolume(e, player, thisBind) {
    var percent = e.offsetX / thisBind.offsetWidth;
    player.volume = percent;
    e.target.value = percent;
    //  player.currentTime = percent * player.duration;
    //  e.target.value = Math.floor(percent / 100);
  }
}

function updateVideoTime(player, time) {
  const timeAll = player.currentTime;
  const currectTime = Math.floor(player.currentTime).toString();
  if (Number.isNaN(timeAll)) {
    time.innerHTML = '';
  } else {
    time.innerHTML = formatSecondsAsTime(currectTime);
  }
}

function playPauseVideo(player, item, playerContainer) {
  if (player.paused || player.ended) {
    // Change the button to a pause button
    changeButtonType(item, 'pause');
    playerContainer.classList.remove('pause');
    const videos = document.querySelectorAll('.video__player');
    videos.forEach(item => {
      item.querySelector('video').pause();
    });
    player.play();
  } else {
    // Change the button to a play button
    changeButtonType(item, 'play');
    playerContainer.classList.add('pause');
    player.pause();
  }
}

// Stop the current media from playing, and return it to the start position
function stopVideo(player) {
  player.pause();
  if (player.currentTime) player.currentTime = 0;
}

// Toggles the media player's mute and unmute status
function muteVolume(player, itemMute) {
  if (player.muted) {
    // Change the button to a mute button
    itemMute.classList.remove('mute');
    player.muted = false;
  } else {
    // Change the button to an unmute button
    itemMute.classList.add('mute');
    player.muted = true;
  }
}

// Replays the media currently loaded in the player
function replayVideo(player) {
  resetPlayer();
  player.play();
}

// Update the progress bar
function updateProgressBar(player, progressBar) {
  // Work out how much of the media has played via the duration and currentTime parameters
  var percentage = Math.floor((100 / player.duration) * player.currentTime);
  // Update the progress bar's value
  progressBar.value = percentage;
  // Update the progress bar's text (for browsers that don't support the progress element)
  progressBar.innerHTML = percentage + '% played';
}

// Updates a button's title, innerHTML and CSS class
function changeButtonType(item, type) {
  let videoPlay = item.querySelector('.video__controls__play');
  let videoStop = item.querySelector('.video__controls__stop');
  if (type === 'play') {
    videoPlay.classList.remove('hidde');
    videoStop.classList.add('hidde');
  }
  if (type === 'pause') {
    videoPlay.classList.add('hidde');
    videoStop.classList.remove('hidde');
  }
}

// function resetPlayer() {
//   progressBar.value = 0;
//   // Move the media back to the start
//   player.currentTime = 0;
//   // Set the play/pause button to 'play'
//   changeButtonType(btnPlayPause, 'play');
// }

// function exitFullScreen() {
//   if (document.exitFullscreen) {
//     document.exitFullscreen();
//   } else if (document.msExitFullscreen) {
//     document.msExitFullscreen();
//   } else if (document.mozCancelFullScreen) {
//     document.mozCancelFullScreen();
//   } else if (document.webkitExitFullscreen) {
//     document.webkitExitFullscreen();
//   }
// }

// function toggleFullScreen() {
//   //var player = document.getElementById("player");

//   if (player.requestFullscreen)
//     if (document.fullScreenElement) {
//       document.cancelFullScreen();
//     } else {
//       player.requestFullscreen();
//     }
//   else if (player.msRequestFullscreen)
//     if (document.msFullscreenElement) {
//       document.msExitFullscreen();
//     } else {
//       player.msRequestFullscreen();
//     }
//   else if (player.mozRequestFullScreen)
//     if (document.mozFullScreenElement) {
//       document.mozCancelFullScreen();
//     } else {
//       player.mozRequestFullScreen();
//     }
//   else if (player.webkitRequestFullscreen)
//     if (document.webkitFullscreenElement) {
//       document.webkitCancelFullScreen();
//     } else {
//       player.webkitRequestFullscreen();
//     }
//   else {
//     alert('Fullscreen API is not supported');
//   }
// }

function initAudio() {
  const audioPlayerContainer = document.querySelectorAll('.row_audio');
  if (audioPlayerContainer.length !== 0) {
    audioPlayerContainer.forEach(item => controlAudio(item));
  }
}

function initScrollBarMobile() {
  const nextSectionContainer = document.querySelectorAll(
    '.nextSection_container'
  );
  if (nextSectionContainer.length !== 0) {
    if (window.innerWidth < 1170) {
      nextSectionContainer.forEach(item => {
        const mapContainer = item.querySelector('.full_map');
        if (!mapContainer) {
          new SimpleBar(item, {
            autoHide: true
          });
        }
      });
    }
  }
}

function nav(e, id = null, hash = null) {
  if (!load) {
    return null;
  }
  load = false;
  const body = document.querySelector('body');
  if (
    body.classList.contains('single-post') ||
    body.classList.contains('archive')
  ) {
  } else {
    e.preventDefault();
    const templatePost = document.querySelector('.post-template-default');
    const templateArchive = document.querySelector('.archive');
    if (templatePost || templateArchive) {
      return null;
    }
    const logo = document.querySelector('.logo');
    const header = document.querySelector('header');
    const hamburger = document.querySelector('.hamburger');
    const ajaxurl = my_ajax_object.ajaxurl;
    const pageID = id ? id : $(this).data('element');
    const menu = document.querySelector('.nav__left');
    const pastPage = $('.wrapper[data-currentpage=' + currentPageID + ']');
    const pastPastPage = $('.wrapper[data-currentpage=' + pastPageID + ']');
    const nextPage = $('.wrapper[data-currentpage=' + nextPageID + ']');
    const lightboxItem = document.querySelectorAll('.lightbox');
    if (lightboxItem.length !== 0) {
      initLightbox();
    }
    closeTimeLineContent();
    nextPage.remove();
    const nextButton = document.querySelectorAll('.page__next');
    nextButton.forEach(item => {
      item.classList.add('load');
    });
    const pastButton = document.querySelectorAll('.page__past');
    pastButton.forEach(item => {
      item.classList.add('load');
    });
    menu.classList.remove('active');
    logo.classList.remove('menu-acitve');
    header.classList.remove('menu-acitve');
    hamburger.classList.remove('active');
    const data = {
      pageID,
      action: 'ajax_section_get_page'
    };
    $.ajax({
      url: ajaxurl,
      type: 'post',
      data: data,
      error: function(response) {
        console.log(response);
      },
      success: function(response) {
        //check
        setTimeout(() => {
          $('.page__load').append(response);
          // $('.page__load').html('');

          pastPage.animate({ marginTop: '-100vh' }, { duration: 500 });

          currentPageID = pageID;
          $('.wrapper[data-container=' + currentPageID + ']').addClass('show');
          const currentPageMenuId = document.querySelector('.wrapper.show')
            .dataset.menu;
          menuActiveID = currentPageMenuId;

          const buttonNext = document.querySelector('.show .page__next span');
          if (buttonNext) {
            buttonNext.addEventListener('click', changePageNext);
          }
          const buttonPast = document.querySelector('.show .page__past span');
          pastPastPageID = buttonPast.dataset.past;
          if (buttonPast) {
            buttonPast.addEventListener('click', changePagePast);
          }
          // console.log($('.wrapper[data-container=' + currentPageID + ']'));
          $('.nav__left__item').removeClass('nav__left__item--active');
          $('.nav__left__item[data-item=' + currentPageID + ']').addClass(
            'nav__left__item--active'
          );
          const currentPageYear = $(
            '.wrapper[data-container=' + currentPageID + ']'
          )[0].dataset.year;

          const timeLineYear = document.querySelector(
            '.timeline__header__year'
          );
          timeLineYear.innerHTML = currentPageYear;
        }, 1000);
        setTimeout(() => {
          pastPage.remove();
          pastPastPage.remove();
          subMenuCategory();
          updetaTimeline();

          const logoColor = document.querySelector('.wrapper.show').dataset
            .logocolor;
          const currentUrl = document.querySelector('.wrapper.show').dataset
            .url;
          window.history.pushState('', '', currentUrl);
          const logoChange = document.querySelectorAll('.logo.load path');
          logoChange.forEach(item => {
            item.style.fill = logoColor;
          });
          // logo.classList.add('load');
          pastLoad();
          nextLoad();
          initSlider();
          // initScrollBarMobile();
          // initParalax();
          initVideo();
          maxWidthImage();
          initAudio();
          if (hash) {
            const number = hash.substring(1);
            $(document.querySelector('.show .seciton__slider')).trigger(
              'to.owl.carousel',
              number
            );
          }
        }, 1500);
        setTimeout(() => {
          load = true;
          nextButton.forEach(item => {
            item.classList.remove('load');
          });
          pastButton.forEach(item => {
            item.classList.remove('load');
          });
          // pageNextButton.classList.remove('loading');
          // pagePastButton.classList.remove('loading');
        }, disableChangePage);
      }
    });
  }
}

function timelineDataLoad(e) {
  // simpleBar = null;
  const ajaxurl = my_ajax_object.ajaxurl;
  const pageID = $(this).data('timelinecontent');

  const timeLineContent = document.querySelector('.timeline__info__content');
  delete timeLineContent.dataset.simplebar;
  timeLineContent.innerHTML =
    '<div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
  const data = {
    pageID,
    action: 'ajax_timeline_get_content'
  };
  $.ajax({
    url: ajaxurl,
    type: 'post',
    data: data,
    error: function(response) {
      console.log(response);
    },
    success: function(response) {
      //check
      setTimeout(() => {
        // console.log(response);
        timeLineContent.innerHTML =
          '<div class="content_scrool_' + scrool + '">' + response + '</div>';
        tmpScrool = document.querySelector('.content_scrool_' + scrool);
        const simpleBar = new SimpleBar(tmpScrool, {
          autoHide: false
        });
        if (scroolHash) {
          const id = scroolHash.substring(1);

          let element = document.querySelector(
            '.simplebar-content [id=' + id + ']'
          );
          let elementTop = element.offsetTop;
          tmpScrool.SimpleBar.getScrollElement().scrollTop = elementTop;
          // $(document.querySelector('.show .seciton__slider' + id));
        }
        const lightboxItem = document.querySelectorAll('.lightbox');
        if (lightboxItem.length !== 0) {
          initLightbox();
        }
      }, 1000);
      setTimeout(() => {
        initVideo();
        maxWidthImage();
        initAudio();
        scrool++;
        scroolHash = false;
      }, 1300);
    }
  });
}

function changePagePast() {
  if (!load) {
    return null;
  }
  load = false;
  const pastButton = document.querySelectorAll('.page__past');
  pastButton.forEach(item => {
    item.classList.add('load');
  });
  const nextButton = document.querySelectorAll('.page__next');
  nextButton.forEach(item => {
    item.classList.add('load');
  });
  // console.log(currentPageID);
  // console.log(nextPageID);
  // console.log(currentPageID);
  // console.log(pastPageID);
  // console.log(pastPastPageID);
  const pastPage = $('.wrapper[data-container=' + pastPageID + ']');
  const currentPage = $('.wrapper[data-container=' + currentPageID + ']');
  const naxtPage = $('.wrapper[data-container=' + nextPageID + ']');

  pastPage.animate({ marginTop: '0vh' }, { duration: 500 });
  currentPage.removeClass('show');
  $('.wrapper[data-container=' + pastPageID + ']').addClass('show');
  const lightboxItem = document.querySelectorAll('.lightbox');
  if (lightboxItem.length !== 0) {
    initLightbox();
  }
  closeTimeLineContent();
  setTimeout(() => {
    naxtPage.remove();
    nextPageID = currentPageID;
    currentPageID = pastPageID;
    pastPageID = pastPastPageID;
    // console.log('<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>');
    // console.log(nextPageID);
    // console.log(currentPageID);
    // console.log(pastPageID);
    // console.log(document.querySelector('.wrapper.show .page__past span'));
    let pastPastPage = document.querySelector('.wrapper.show .page__past span');
    if (pastPastPage) {
      pastPastPageID = pastPastPage.dataset.past;
    } else {
      pastPastPageID = 0;
    }
    const currentPageYear = document.querySelector('.wrapper.show').dataset
      .year;
    const currentPageMenuId = document.querySelector('.wrapper.show').dataset
      .menu;
    const currentUrl = document.querySelector('.wrapper.show').dataset.url;
    i = document.querySelector('.wrapper.show').dataset.currentpage;
    menuActiveID = currentPageMenuId;

    window.history.pushState('', '', currentUrl);
    const timeLineYear = document.querySelector('.timeline__header__year');
    timeLineYear.innerHTML = currentPageYear;
    $('.nav__left__item').removeClass('nav__left__item--active');
    $('.nav__left__item[data-item=' + menuActiveID + ']').addClass(
      'nav__left__item--active'
    );
    const logoColor = document.querySelector('.wrapper.show').dataset.logocolor;
    const logoChange = document.querySelectorAll('.logo.load path');
    logoChange.forEach(item => {
      item.style.fill = logoColor;
    });
    pastLoad();
    // initScrollBarMobile();
    subMenuCategory();
    updetaTimeline();
    initVideo();
    initAudio();
    maxWidthImage();
    initLinkAction();
    // initParalax();
    initSlider();
  }, 600);
  setTimeout(() => {
    load = true;
    pastButton.forEach(item => {
      item.classList.remove('load');
    });
    nextButton.forEach(item => {
      item.classList.remove('load');
    });
  }, disableChangePage);
}

function changePageNext() {
  if (!load) {
    return null;
  }
  load = false;
  const nextButton = document.querySelectorAll('.page__next');
  nextButton.forEach(item => {
    item.classList.add('load');
  });
  const pastButton = document.querySelectorAll('.page__past');
  pastButton.forEach(item => {
    item.classList.add('load');
  });
  // const pageNextButton = document.querySelector('.page__next');
  // const pagePastButton = document.querySelector('.page__past');
  // pageNextButton.classList.add('loading');
  // pagePastButton.classList.add('loading');

  const pastPage = $('.wrapper[data-container=' + currentPageID + ']');
  pastPage.animate({ marginTop: '-100vh' }, { duration: 500 });
  pastPage.removeClass('show');
  $('.wrapper[data-container=' + nextPageID + ']').addClass('show');
  const lightboxItem = document.querySelectorAll('.lightbox');
  if (lightboxItem.length !== 0) {
    initLightbox();
  }
  closeTimeLineContent();
  setTimeout(() => {
    // pastPage.remove();
    pastPastPageID = pastPageID;
    pastPageID = currentPageID;
    currentPageID = nextPageID;
    if (pastPastPageID) {
      const pastPastPage = $('.wrapper[data-container=' + pastPastPageID + ']');
      pastPastPage.remove();
    }

    const currentPageYear = document.querySelector('.wrapper.show').dataset
      .year;
    const currentPageMenuId = document.querySelector('.wrapper.show').dataset
      .menu;
    i = document.querySelector('.wrapper.show').dataset.currentpage;
    menuActiveID = currentPageMenuId;
    const currentUrl = document.querySelector('.wrapper.show').dataset.url;
    window.history.pushState('', '', currentUrl);
    const timeLineYear = document.querySelector('.timeline__header__year');
    timeLineYear.innerHTML = currentPageYear;
    $('.nav__left__item').removeClass('nav__left__item--active');
    $('.nav__left__item[data-item=' + menuActiveID + ']').addClass(
      'nav__left__item--active'
    );
    const logoColor = document.querySelector('.wrapper.show').dataset.logocolor;
    const logoChange = document.querySelectorAll('.logo.load path');
    logoChange.forEach(item => {
      item.style.fill = logoColor;
    });
    nextLoad();
    // initScrollBarMobile();
    subMenuCategory();
    updetaTimeline();
    initVideo();
    initAudio();
    maxWidthImage();
    initLinkAction();
    // initParalax();
    initSlider();
  }, 600);
  setTimeout(() => {
    load = true;
    nextButton.forEach(item => {
      item.classList.remove('load');
    });
    pastButton.forEach(item => {
      item.classList.remove('load');
    });
    // pageNextButton.classList.remove('loading');
    // pagePastButton.classList.remove('loading');
  }, disableChangePage);
}

function initParalax() {
  const wrapper = document.querySelectorAll('.wrapper');
  const movedBackground = $('.wrapper .section');
  const layers = document.querySelectorAll('.wrapper .container>*');
  const layers2 = document.querySelectorAll('.wrapper .column>*');

  if (window.innerWidth > 1170 && window.innerHeight > 750) {
    // layers.forEach(element => {
    //   $(element).css('bottom', '16.5867px');
    //   $(element).css('right', '15.5px');
    // });
    // layers2.forEach(element => {
    //   $(element).css('bottom', '16.5867px');
    //   $(element).css('right', '15.5px');
    // });
    wrapper.forEach(item => {
      item.addEventListener('mousemove', function(e) {
        layers.forEach(element => {
          var change;
          var xpos = e.clientX;
          var ypos = e.clientY;
          var left = change * 20;
          var xpos = xpos * 3;
          ypos = ypos * 2;
          element.style.transform = `translate(${0 - xpos / 420}px, ${0 -
            ypos / 120}px)`;
          // $(element).css('bottom', 0 + ypos / 75 + 'px');
          // $(element).css('right', 0 + xpos / 120 + 'px');
        });
        layers2.forEach(element => {
          var change;
          var xpos = e.clientX;
          var ypos = e.clientY;
          var left = change * 20;
          var xpos = xpos * 3;
          ypos = ypos * 2;
          element.style.transform = `translate(${0 - xpos / 420}px, ${0 -
            ypos / 120}px)`;
          // $(element).css('bottom', 0 + ypos / 75 + 'px');
          // $(element).css('right', 0 + xpos / 120 + 'px');
        });
      });
    });

    movedBackground.mousemove(function(e) {
      const moveX = (e.pageX * -1) / 15;
      const moveY = (e.pageY * -1) / 15;
      $('.page__background').css(
        'background-position',
        moveX + 'px ' + moveY + 'px'
      );
    });
  }
}

jQuery(document).ready(function($) {
  const templatePost = document.querySelector('.post-template-default');
  const templateArchive = document.querySelector('.archive');
  const body = document.querySelector('body');
  if (!templatePost && !templateArchive) {
    firstLoad();
  } else {
    const logo = document.querySelector('.logo');
    if (logo) {
      logo.classList.add('load');
    }
  }
  setTimeout(() => {}, 100);
  $('.nav__left__item a').on('click', nav);
  if (!body.classList.contains('single-post')) {
    $('.logo a').on('click', nav);
  }
});
